import { HeroResultSectionContainer } from '../../containers/HeroResultSectionContainer';
import { ValuationFiltersContainer } from '../../containers/ValuationFiltersContainer';
import { ErrorResult } from '../MarketPrice';
import * as React from 'react';
import { useScrollingRef } from '../../containers/Scrolling';
import { EScrollingBlocks } from '../../constants/scrollingBlocks';

export const ErrorScreen = () => {
  const valuationFiltersRef = useScrollingRef(EScrollingBlocks.ValuationFilters);

  return (
    <>
      <HeroResultSectionContainer />
      <ValuationFiltersContainer refWrapper={valuationFiltersRef} />
      <ErrorResult />
    </>
  );
};
